import { render } from "./kitchenSales.vue?vue&type=template&id=afef0890&scoped=true"
import script from "./kitchenSales.vue?vue&type=script&lang=js"
export * from "./kitchenSales.vue?vue&type=script&lang=js"

import "./kitchenSales.vue?vue&type=style&index=0&id=afef0890&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afef0890"]])

export default __exports__